import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';

const FixedWidgets = () => {
  const [showEmergency, setShowEmergency] = useState(false);
  const [showWhatsApp, setShowWhatsApp] = useState(false);

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col space-y-4">
      {/* Emergency Call */}
      <div className="relative">
        <AnimatePresence>
          {showEmergency && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="absolute right-16 top-1/2 -translate-y-1/2 bg-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap"
            >
              <p className="text-sm font-semibold text-gray-800">Emergency: 08362228390</p>
            </motion.div>
          )}
        </AnimatePresence>
        <motion.a
          href="tel:08362228390"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onHoverStart={() => setShowEmergency(true)}
          onHoverEnd={() => setShowEmergency(false)}
          className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-full shadow-lg hover:bg-red-700 transition-colors duration-300"
        >
          <motion.div
            animate={{ rotate: [0, 10, -10, 10, 0] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 3 }}
          >
            <Phone className="text-white" size={24} />
          </motion.div>
        </motion.a>
      </div>

      <div className="relative">
        <AnimatePresence>
          {showEmergency && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="absolute right-16 top-1/2 -translate-y-1/2 bg-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap"
            >
              <p className="text-sm font-semibold text-gray-800">Emergency: 917996524417</p>
            </motion.div>
          )}
        </AnimatePresence>
        <motion.a
          href="tel:917996524417"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onHoverStart={() => setShowEmergency(true)}
          onHoverEnd={() => setShowEmergency(false)}
          className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-full shadow-lg hover:bg-red-700 transition-colors duration-300"
        >
          <motion.div
            animate={{ rotate: [0, 10, -10, 10, 0] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 3 }}
          >
            <Phone className="text-white" size={24} />
          </motion.div>
        </motion.a>
      </div>

      {/* WhatsApp */}
      <div className="relative">
        <AnimatePresence>
          {showWhatsApp && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="absolute right-16 top-1/2 -translate-y-1/2 bg-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap"
            >
              <p className="text-sm font-semibold text-gray-800">WhatsApp Us</p>
            </motion.div>
          )}
        </AnimatePresence>
        <motion.a
          href="https://wa.me/917996524417"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onHoverStart={() => setShowWhatsApp(true)}
          onHoverEnd={() => setShowWhatsApp(false)}
          className="flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:bg-[#20BA5A] transition-colors duration-300"
        >
          <MessageCircle className="text-white" size={24} />
        </motion.a>
      </div>
    </div>
  );
};

export default FixedWidgets;